export const formPermissions = {
    CREATE: {
        key: 'Forms.Create',
        name: 'Create Forms',
        description: 'Create and update custom forms'
    }
}